export default "__VITE_ASSET__RKVLzbBK__"